import React from 'react';
import { Origin } from '../../manage-installed-apps-page';
import {
  MessageBoxFunctionalLayout,
  Modal,
  TextButton,
} from '@wix/design-system';
import { useTranslation } from '../../../hooks/use-translation';

interface IDeleteHybridAppModalProps {
  appName: string;
  origin: Origin;
  editorUrl: string;
  handleClose(): void;
}

export const DeleteHybridAppModal = ({
  appName,
  origin,
  editorUrl,
  handleClose,
}: IDeleteHybridAppModalProps) => {
  const t = useTranslation();
  const title = t('manage-apps.delete-hybrid-header', {
    name: appName,
  }).replace('&amp;', '&');

  const learnMoreTextButton = (
    <TextButton
      as="a"
      href={t('manage-apps.delete-hybrid-learn-more-link')}
      target="_blank"
      onClick={handleClose}
    >
      {t('manage-apps.delete-hybrid-learn-more')}
    </TextButton>
  );

  const confirmText =
    origin === Origin.EDITOR
      ? t('manage-apps.delete-hybrid-editor-cta')
      : t('manage-apps.delete-hybrid-dashboard-cta');
  const onOkClick = () => {
    if (origin === Origin.BIZMGR) {
      window.open(editorUrl, '_blank');
    }
    handleClose();
  };

  return (
    <Modal isOpen>
      <MessageBoxFunctionalLayout
        closeButton
        theme="blue"
        title={title}
        sideActions={learnMoreTextButton}
        confirmText={confirmText}
        onOk={onOkClick}
        onClose={handleClose}
        dataHook="delete-hybrid-app-modal"
      >
        {t('manage-apps.delete-hybrid-line1')}
        <br />
        <br />
        {t('manage-apps.delete-hybrid-line2')}
        <br />
        {t('manage-apps.delete-hybrid-line3')}
      </MessageBoxFunctionalLayout>
    </Modal>
  );
};
